import {
  Avatar,
  Box,
  Card,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import config from "configs/config";
import { setNotification } from "context";
import { useMaterialUIController } from "context";
import { setTopicVisible } from "controllers/ForumController";
import { getTopicsFromServer } from "controllers/ForumController";
import { getForumGroupFromServer } from "controllers/ForumController";
import { getUnreadedNotifications } from "controllers/NotificationController";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useRef, useState } from "react";
import Swal from "sweetalert2";
import getText from "Translator";
import Chat from "./Chat";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { setAction } from "context";
import { setLoading } from "context";
import { setHeader } from "context";
import { setTitle } from "context";
import { errorMessage } from "components/AlertComponent";
import { useNavigate, useParams } from "react-router";

let isForumAdmin = false;

let emptyState = {
  pageMode: "topic",
  summary: "",
  summaryHeight: -1,
  pageTitle: "",
  btnTopicGroupVisible: true,
  forumGroupList: [],
  selectedForumGroupTitle: "Public",
  topicList: [],
  forumList: [],
  commentText: "",
  attachedList: [],
  attachedIconVisible: false,
  shareIconVisible: false,
  isMyComment: false,
  selectedFile: "",
  connectionState: true,
  noticationcount: "0",
};
let capsule = "";
let file = "";
let forumGroup = "";
let openFrom = "";
let fileInfo;
export default function ChatroomView(props) {
  const [controller, dispatch] = useMaterialUIController();

  const [details, setDetails] = useState(emptyState);
  const [open, setOpen] = useState(false);
  const [reload, setReload] = useState(new Date());
  const myRef = useRef(null);
  const params = useParams();
  const navigate = useNavigate();
  const getFileInfo = async () => {
    try {
      fileInfo = await localStorage.getItem("$menu");
      if (fileInfo) {
        fileInfo = JSON.parse(fileInfo);
        capsule = fileInfo.capsule;
        openFrom = fileInfo.openFrom;
        file = fileInfo.file;

        if (file === "") {
          if (params.selected) {
            forumGroup = params.selected;
          } else {
            forumGroup = fileInfo.capsule;
          }
          await createTopics("");
        } else {
          forumGroup = fileInfo.file;
          let newStates = details;
          newStates.pageMode = "chat";
          setDetails(newStates);
          setReload(new Date());
        }
      }
      setLoading(dispatch, false);
    } catch (err) {
      errorMessage(err, 5001);
    }
  };
  const createTopics = async (search) => {
    try {
      let groupdetails = [];
      groupdetails = await getForumGroupFromServer({ capsule }, controller); //realm.objects(tblForumGroup)[0];

      if (groupdetails.success) {
        let newStates = details;
        if (params.selected) {
          forumGroup = params.selected;
          newStates.selectedForumGroupTitle = groupdetails.data.filter(
            (a) => a.id + "" === params.selected + ""
          )[0].text;
        } else {
          forumGroup = groupdetails.data[0].id;
          newStates.selectedForumGroupTitle = groupdetails.data[0].text;
        }
        setTitle(dispatch, {
          title: fileInfo.capsuleText,
          subtitle:
            getText("selectedgroup", "fa") +
            " : " +
            newStates.selectedForumGroupTitle,
        });

        setDetails(newStates);
        setReload(new Date());
        addToTopic("");
      } else {
      }
    } catch (err) {
      errorMessage(err, 5001);
    }
  };

  const setNotificationCount = async () => {
    try {
      if (controller.authenticated) {
        let result = await getUnreadedNotifications(controller);
        if (result.success) {
          if (result.data !== controller.notification) {
            setNotification(dispatch, result.data);
          }
        } else {
        }
      }
    } catch (err) {}
  };
  useEffect(() => {
    setHeader(dispatch, "backpage-selectgroup");
    (async () => {
      setNotificationCount();

      fileInfo = undefined;
      getFileInfo();
      if (myRef.current !== null) {
        myRef.current.scrollIntoView();
      }
    })();
    return () => {
      fileInfo = undefined;
    };
  }, []);

  useEffect(() => {
    (async () => {
      if (controller.action) {
        if (controller.action.startsWith("backpage")) {
          handleBackButtonClick();
        } else if (controller.action.startsWith("selectgroup")) {
          SetForumGroups();
        } else {
          // getFileInfo();
        }
        setAction(dispatch, "");
      }
    })();
  }, [controller.action]);

  const handleBackButtonClick = async () => {
    if (details.pageMode === "chat") {
      if (openFrom !== "") {
        openFrom = "";
        fileInfo = await localStorage.getItem("$menu");
        fileInfo = JSON.parse(fileInfo);
        fileInfo.openFrom = "";
        await localStorage.setItem("$menu", JSON.stringify(fileInfo));
        navigate(-1);
        return;
      }
      let newDetails = details;
      newDetails.pageMode = "topic";
      newDetails.attachedIconVisible = false;
      newDetails.shareIconVisible = false;
      setDetails(newDetails);
      setReload(new Date());
      setHeader(dispatch, "backpage-selectgroup");
    } else {
      if (params.selected) {
        navigate("/notification");
      } else {
        navigate(-1);
      }
    }
  };
  const SetForumGroups = async () => {
    setOpen(true);
    let newDetails;
    newDetails = details;
    let newData = {
      capsule: fileInfo.capsule,
    };
    let fg = await getForumGroupFromServer(newData, controller);
    if (fg.success) {
      newDetails.forumGroupList = fg.data;

      setDetails(newDetails);

      setReload(new Date());
    }
  };
  const addToTopic = async (search) => {
    try {
      let newData = {
        capsule,
        forumGroup,
      };
      let topics = await getTopicsFromServer(newData, controller);
      if (topics.success) {
        let newDetails = details;
        newDetails.topicList = topics.data;
        newDetails.pageMode = "topic";
        setDetails(newDetails);
        setReload(new Date());
      }
    } catch (err) {
      errorMessage(err, 5001);
    }
  };
  const setTopicVisibleHamdler = async (id, visible, showWithAdmin) => {
    let newData = {
      id,
      visible,
      showWithAdmin,
    };
    let result = await setTopicVisible(newData, controller);
    if (result.success) {
      Swal.fire({
        title: "",
        text: getText("alertsuccess", "fa"),
        confirmButtonText: getText("ok", "fa"),
      });
      addToTopic("");
    } else {
      Swal.fire({
        title: "",
        text: getText("warningalert", "fa"),
        confirmButtonText: getText("ok", "fa"),
      });
    }
  };
  const goToChat = (file, summary, isAdmin) => {
    isForumAdmin = isAdmin;
    openFrom = "";
    fileInfo.file = file;
    let newStates = details;
    newStates.pageMode = "chat";
    newStates.summary = summary;

    setDetails(newStates);
    setReload(new Date());
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div className={"fa" === "en" ? "listmenu" : "listmenu rtl"}>
        <div style={{ width: "100%", height: 45 }} ref={myRef}></div>

        {fileInfo && details.connectionState && details.pageMode === "chat" && (
          <div style={{ flex: 1 }}>
            <Chat
              isForumAdmin={isForumAdmin}
              //x socket={socket}
              file={fileInfo.file}
              capsule={fileInfo.capsule}
              forumGroup={fileInfo.openFrom !== "" ? fileInfo.file : forumGroup}
              openFrom={fileInfo.openFrom}
              props={props}
              fileInfo={fileInfo}
            />
          </div>
        )}

        {details.connectionState && details.pageMode !== "chat" && (
          <div style={{ margin: 8 }}>
            {details.topicList &&
              details.topicList.map((item, index) => (
                <Card
                  style={{
                    borderColor: "#039dfc",
                    padding: 7,
                    borderRadius: 5,
                    marginTop: 5,
                  }}
                >
                  <div style={{ display: "flex" }}>
                    <Avatar
                      alt={item.name}
                      src={config.fileserver + "/images/" + item.picture}
                      onClick={() => {
                        goToChat(item.file, item.summary, item.isAdmin);
                      }}
                    />
                    <div
                      style={{
                        width: "90%",
                        lineHeight: "38px",
                        marginLeft: 10,
                        marginRight: 10,
                        color: "#039dfc",
                        fontWeight: "bold",
                        fontSize: 11,
                      }}
                      onClick={() => {
                        goToChat(item.file, item.summary, item.isAdmin);
                      }}
                    >
                      {item.name + " - " + item.sendToForumDate}
                    </div>
                    {item.isAdmin &&
                      (item.showWithAdmin === true ||
                        item.deleteWithAdmin === true) && (
                        <Box style={{ alignItems: "end" }}>
                          <IconButton
                            color="primary"
                            className="iconButton"
                            aria-label="attach"
                            onClick={() => {
                              setTopicVisibleHamdler(
                                item.id,
                                !item.visible,
                                item.showWithAdmin
                              );
                            }}
                          >
                            {item.visible === false && (
                              <VisibilityOffOutlinedIcon />
                            )}
                            {item.visible === true && (
                              <VisibilityOutlinedIcon />
                            )}
                          </IconButton>
                        </Box>
                      )}
                  </div>
                  <div
                    style={{
                      textAlign: "justify",
                      fontSize: "15px",
                      maxHeight: 140,
                    }}
                    onClick={() => {
                      goToChat(item.file, item.summary, item.isAdmin);
                    }}
                  >
                    <div
                      dangerouslySetInnerHTML={{ __html: item.resultText }}
                    />
                  </div>
                </Card>
              ))}
          </div>
        )}

        <Drawer
          anchor="bottom"
          open={open}
          onClose={() => {
            setOpen(false);
          }}
        >
          <div className="drawertitle">
            <IconButton
              style={{
                color: "#039dfc",
                height: 35,
                width: 35,
                top: 5,
                backgroundColor: "#FFF",
                position: "absolute",
                right: 5,
              }}
              className="iconButton"
              aria-label="CloseIcon"
              onClick={() => {
                setOpen(false);
              }}
            >
              <CloseIcon />
            </IconButton>
            {getText("selectedgroup", "fa")}
          </div>
          <div className="drawertext">
            {details.pageMode === "topic" && (
              <List>
                {details.forumGroupList &&
                  details.forumGroupList.map((item, index) => (
                    <ListItem
                      key={item.id}
                      autoFocus
                      button
                      onClick={() => {
                        forumGroup = item.id;

                        let newStates = details;

                        newStates.selectedForumGroupTitle = item.text;
                        setDetails(newStates);
                        setReload(new Date());
                        setTitle(dispatch, {
                          title: fileInfo.capsuleText,
                          subtitle:
                            getText("selectedgroup", "fa") +
                            " : " +
                            details.selectedForumGroupTitle,
                        });

                        addToTopic("");
                        setOpen(false);
                      }}
                    >
                      <ListItemText primary={item.text} />
                    </ListItem>
                  ))}
              </List>
            )}
          </div>
        </Drawer>
      </div>
      <Footer />
    </DashboardLayout>
  );
}
